var path = 'modules/dcb-eaccount.pages.eadashboard/components/nextDueDate.tpl.html';
var html = "<div ng-controller=\"NextDueDateController as controller\">\n<div class=\"portlet-body\"ng-class=\"{loading : controller.loading}\" >\n    <dc-spinner></dc-spinner>\n    <h3 class=\"plain-heading\"><small data-i18n=\"modules.dashboard.nextduedate\"></small><br>\n        {{controller.value | dt:'shortDate'}}</h3>\n</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/eaDashboard/components&prefix=modules/dcb-eaccount.pages.eadashboard/components!./~/raw-loader!./src/ui/modules/eaDashboard/components/nextDueDate.tpl.html
// module id = 907
// module chunks = 12